import ruleNames, { RuleNames } from '../../../constants/ruleNames';

import AdverseMedia from '../ruleParamsForms/AdverseMedia';
import Affordability from '../ruleParamsForms/Affordability';
import AgeThreshold from '../ruleParamsForms/AgeThreshold';
import AmountThreshold from '../ruleParamsForms/AmountThreshold';
import AnomalyDetection from '../ruleParamsForms/AnomalyDetection';
import BusinessAuditor from '../ruleParamsForms/BusinessAuditor';
import BusinessSanctionList from '../ruleParamsForms/BusinessSanctionList';
import CarFreqHistoricalOwners from '../ruleParamsForms/CarFreqHistoricalOwners';
import CarValuation from '../ruleParamsForms/CarValuation';
import CashFlow from '../ruleParamsForms/CashFlow';
import CategorizationAmountThreshold from '../ruleParamsForms/CategorizationAmountThreshold';
import CategorizationFrequency from '../ruleParamsForms/CategorizationFrequency';
import CategorizationRollingSum from '../ruleParamsForms/CategorizationRollingSum';
import Collector from '../ruleParamsForms/Collector';
import ConnectedEntities from '../ruleParamsForms/ConnectedEntities';
import CountryList from '../ruleParamsForms/CountryList';
import CountryListNoPurchase from '../ruleParamsForms/CountryListNoPurchase';
import CreditRisk from '../ruleParamsForms/CreditRisk';
import DatapointConflict from '../ruleParamsForms/DatapointConflict';
import DetectNewIp from '../ruleParamsForms/DetectNewIp';
import DueDiligence from '../ruleParamsForms/DueDiligence';
import EmploymentType from '../ruleParamsForms/EmploymentType';
import EntityConnectedAccountCount from '../ruleParamsForms/EntityConnectedAccountCount';
import Frequency from '../ruleParamsForms/Frequency';
import IndividualCriminalRecord from '../ruleParamsForms/IndividualCriminalRecord';
import IndividualPep from '../ruleParamsForms/IndividualPep';
import IndividualSanctionList from '../ruleParamsForms/IndividualSanctionList';
import IpCountryBlocklist from '../ruleParamsForms/IpCountryBlocklist';
import KycValid from '../ruleParamsForms/KycValid';
import LowIncome from '../ruleParamsForms/LowIncome';
import RelatedIndividualsCriminalRecord from '../ruleParamsForms/RelatedIndividualsCriminalRecord';
import SimpleAnomalyDetection from '../ruleParamsForms/SimpleAnomalyDetection';
import SimpleAnomalyDetectionWithoutWindow from '../ruleParamsForms/SimpleAnomalyDetectionWithoutWindow';
import SharedIpEntityCount from '../ruleParamsForms/SharedIpEntityCount';
import EntityDistinctIpCount from '../ruleParamsForms/EntityDistinctIpCount';
import SustainedForeignIpCountry from '../ruleParamsForms/SustainedForeignIpCountry';
import SniCodeBlocklist from '../ruleParamsForms/SniCodeBlocklist';
import SourceOfFunds from '../ruleParamsForms/SourceOfFunds';
import SourceOfIncome from '../ruleParamsForms/SourceOfIncome';
import SuspiciousFunds from '../ruleParamsForms/SuspiciousFunds';
import ThresholdWithKycData from '../ruleParamsForms/ThresholdWithKycData';
import TimeWindow from '../ruleParamsForms/TimeWindow';
import TransactionMonitoringTypicalAmount from '../ruleParamsForms/TransactionMonitoringTypicalAmount';
import TransactionNameMatching from '../ruleParamsForms/TransactionNameMatching';
import InvoicePaidByIssuer from '../ruleParamsForms/InvoicePaidByIssuer';
import TransactionRollingSum from '../ruleParamsForms/TransactionRollingSum';
import UpdateFreqOnly from '../ruleParamsForms/UpdateFreqOnly';
import ZipCodeBlocklist from '../ruleParamsForms/ZipCodeBlocklist';
import MerchantCategoryCode from '../ruleParamsForms/MerchantCategoryCode';
import MultipleIpCountries from '../ruleParamsForms/MultipleIpCountries';
import IpCountryAllowlist from '../ruleParamsForms/IpCountryAllowlist';

const mapRuleParamsForm: Record<RuleNames, React.ComponentType | null> = {
  [ruleNames.ADDITIONAL_DELIVERY_ADDRESS]: UpdateFreqOnly,
  [ruleNames.ADVERSE_MEDIA]: AdverseMedia,
  [ruleNames.AFFORDABILITY]: Affordability,
  [ruleNames.AGE_THRESHOLD]: AgeThreshold,
  [ruleNames.ALWAYS_TRIGGER]: () => null,
  [ruleNames.AMOUNT_THRESHOLD]: AmountThreshold,
  [ruleNames.ANOMALY_DETECTION_INCOMING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_INCOMING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_INCOMING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_INCOMING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_OUTGOING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_PROCESSING_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_AVERAGE]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_FREQUENCY]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION_TOTAL_SINGLE_AMOUNT]: SimpleAnomalyDetectionWithoutWindow,
  [ruleNames.ANOMALY_DETECTION_TOTAL_VOLUME_ROLLING_SUM]: SimpleAnomalyDetection,
  [ruleNames.ANOMALY_DETECTION]: AnomalyDetection,
  [ruleNames.BUSINESS_ACTIVE]: UpdateFreqOnly,
  [ruleNames.BUSINESS_AUDITOR]: BusinessAuditor,
  [ruleNames.BUSINESS_DATA_CHANGED]: null,
  [ruleNames.BUSINESS_EQUITY_SHARE]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }),
  [ruleNames.BUSINESS_EQUITY]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }),
  [ruleNames.BUSINESS_FINANCIAL_STATEMENT_COMMENT]: UpdateFreqOnly,
  [ruleNames.BUSINESS_FTAX]: UpdateFreqOnly,
  [ruleNames.BUSINESS_PAYMENT_APPLICATIONS_SUM]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }),
  [ruleNames.BUSINESS_PAYMENT_APPLICATIONS]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }),
  [ruleNames.BUSINESS_PAYMENT_REMARKS_SUM]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }),
  [ruleNames.BUSINESS_PAYMENT_REMARKS]: () => ThresholdWithKycData({ overrideCurrencies: ['SEK'] }), // At the moment only supports SEK
  [ruleNames.BUSINESS_PROVIDER_WARNING]: UpdateFreqOnly,
  [ruleNames.BUSINESS_SANCTION_LIST]: BusinessSanctionList,
  [ruleNames.BUSINESS_VAT]: UpdateFreqOnly,
  [ruleNames.CAR_FREQ_HISTORICAL_OWNERS]: CarFreqHistoricalOwners,
  [ruleNames.CAR_GUARANTOR_RELATED]: ConnectedEntities,
  [ruleNames.CAR_IN_CIRCULATION]: UpdateFreqOnly,
  [ruleNames.CAR_VALUATION]: CarValuation,
  [ruleNames.CASH_FLOW]: CashFlow,
  [ruleNames.CATEGORIZATION_AMOUNT_THRESHOLD]: CategorizationAmountThreshold,
  [ruleNames.CO_ADDRESS]: UpdateFreqOnly,
  [ruleNames.COLLECTOR]: Collector,
  [ruleNames.CONNECTED_BUYER_SELLER]: UpdateFreqOnly,
  [ruleNames.CONNECTED_ENTITY_PEP]: ConnectedEntities,
  [ruleNames.CONNECTED_ENTITY_SANCTION_LIST]: ConnectedEntities,
  [ruleNames.COUNTRY_CITIZENSHIP_BLACKLIST]: CountryListNoPurchase,
  [ruleNames.COUNTRY_RESIDENCE_BLACKLIST]: CountryList,
  [ruleNames.COUNTRY_RESIDENCE_WHITELIST]: CountryList,
  [ruleNames.CREDIT_RISK]: CreditRisk,
  [ruleNames.DATAPOINT_CONFLICT]: DatapointConflict,
  [ruleNames.DETECT_NEW_IP]: DetectNewIp,
  [ruleNames.DUE_DILIGENCE]: DueDiligence,
  [ruleNames.EMPLOYMENT_TYPE]: EmploymentType,
  [ruleNames.ENTITY_CONNECTED_ACCOUNT_COUNT]: EntityConnectedAccountCount,
  [ruleNames.FOREIGN_ADDRESS]: UpdateFreqOnly,
  [ruleNames.INCOMING_CATEGORIZATION_FREQUENCY]: CategorizationFrequency,
  [ruleNames.INCOMING_CATEGORIZATION_ROLLING_SUM]: CategorizationRollingSum,
  [ruleNames.INCOMING_FREQUENCY]: Frequency,
  [ruleNames.INCOMING_VOLUME_ROLLING_SUM]: TransactionRollingSum,
  [ruleNames.INDIVIDUAL_CRIMINAL_RECORD]: IndividualCriminalRecord,
  [ruleNames.INDIVIDUAL_PEP]: IndividualPep,
  [ruleNames.INDIVIDUAL_SANCTION_LIST]: IndividualSanctionList,
  [ruleNames.IP_ANONYMOUS]: UpdateFreqOnly,
  [ruleNames.IP_COUNTRY_ALLOWLIST]: IpCountryAllowlist,
  [ruleNames.IP_COUNTRY_BLACKLIST]: IpCountryBlocklist,
  [ruleNames.KYC_VALID]: KycValid,
  [ruleNames.LOW_INCOME]: LowIncome,
  [ruleNames.MERCHANT_CATEGORY_CODE_BLOCKLIST]: MerchantCategoryCode,
  [ruleNames.MULTIPLE_IP_COUNTRIES]: MultipleIpCountries,
  [ruleNames.OUTGOING_CATEGORIZATION_FREQUENCY]: CategorizationFrequency,
  [ruleNames.OUTGOING_CATEGORIZATION_ROLLING_SUM]: CategorizationRollingSum,
  [ruleNames.OUTGOING_FREQUENCY]: Frequency,
  [ruleNames.OUTGOING_VOLUME_ROLLING_SUM]: TransactionRollingSum,
  [ruleNames.PROCESSING_FREQUENCY]: Frequency,
  [ruleNames.PROCESSING_VOLUME_ROLLING_SUM]: TransactionRollingSum,
  [ruleNames.RELATED_INDIVIDUALS_CRIMINAL_RECORD]: RelatedIndividualsCriminalRecord,
  [ruleNames.SELLER_OWNS_CAR]: UpdateFreqOnly,
  [ruleNames.SHARED_IP_ENTITY_COUNT]: SharedIpEntityCount,
  [ruleNames.ENTITY_DISTINCT_IP_COUNT]: EntityDistinctIpCount,
  [ruleNames.SUSTAINED_FOREIGN_IP_COUNTRY]: SustainedForeignIpCountry,
  [ruleNames.SNI_CODE_BLACKLIST]: SniCodeBlocklist,
  [ruleNames.SOURCE_OF_FUNDS]: SourceOfFunds,
  [ruleNames.SOURCE_OF_INCOME]: SourceOfIncome,
  [ruleNames.SPAR_CHANGED]: null,
  [ruleNames.SUSPICIOUS_FUNDS]: SuspiciousFunds,
  [ruleNames.TEST_BLOCK]: () => null,
  [ruleNames.TEST_REVIEW]: () => null,
  [ruleNames.TIME_WINDOW]: TimeWindow,
  [ruleNames.TOTAL_CATEGORIZATION_FREQUENCY]: CategorizationFrequency,
  [ruleNames.TOTAL_CATEGORIZATION_ROLLING_SUM]: CategorizationRollingSum,
  [ruleNames.TOTAL_FREQUENCY]: Frequency,
  [ruleNames.TOTAL_VOLUME_ROLLING_SUM]: TransactionRollingSum,
  [ruleNames.TRANSACTION_NAME_MATCHING]: TransactionNameMatching,
  [ruleNames.INVOICE_PAID_BY_ISSUER]: InvoicePaidByIssuer,
  [ruleNames.TRANSACTION_MONITORING_TYPICAL_AMOUNT]: TransactionMonitoringTypicalAmount,
  [ruleNames.ZIP_CODE_BLACKLIST]: ZipCodeBlocklist,
};

export default mapRuleParamsForm;
